import { Injectable } from '@angular/core';
import { CustomActiveCartService } from '@cart/data-access';
import { DeliveryDate } from '@delivery/const';
import { DeliveryActions, OccDeliveryDateService } from '@delivery/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class DeliveryDateEffects {
  loadDeliveryDate$: Observable<DeliveryActions.LoadDeliveryDateSuccess | DeliveryActions.LoadDeliveryDateFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(DeliveryActions.LOAD_DELIVERY_DATE),
        switchMap(() =>
          combineLatest({
            cartId: this.activeCartService.getActiveCartId().pipe(filter(Boolean)),
          }).pipe(take(1)),
        ),
        switchMap(({ cartId }) =>
          this.occDeliveryDateService.loadDeliveryDate(cartId).pipe(
            map((data: DeliveryDate) => new DeliveryActions.LoadDeliveryDateSuccess(data)),
            catchError((error: unknown) => of(new DeliveryActions.LoadDeliveryDateFail(error))),
          ),
        ),
      ),
    );

  constructor(
    private actions$: Actions,
    private occDeliveryDateService: OccDeliveryDateService,
    private activeCartService: CustomActiveCartService,
  ) {}
}
